import axios from 'axios'

const generateLedger =  async function(obj){
    try{
        const   path = `/acc_ledger`
            ,   route = process.env.VUE_APP_API_ROUTE.concat( path )
            ,   response = await axios.post(route, obj)
        return response.data
    }
    catch( error ) {
        return error.response.data
    }
}

export default generateLedger
